module.exports = __webpack_public_path__ + "img/6-cartoon-content.4a420325.jpg";